// @flow
import type {Action} from '../../../state/types'

export type SearchByTextPayload = {
  text: string,
}

const id = 'map/SEARCH_BY_TEXT'

export const searchByText = (text:string): Action<SearchByTextPayload> => ({
  type: id,
  payload: {
    text,
  }
})

searchByText.id = id
